<template>
  <div>
    <div 
      v-for="(item, itemIndex) in items"
      :key="itemIndex"
      class="lv-info-multilayer"
      @click.prevent.stop="$_onClick($event, item, itemIndex)"
    >
      <div  class="lv-info-multilayer__title" >
        <i 
          v-if="item.items && item.items.length"
          class="lv-info-multilayer__icon icon-chevron-up"
          :class="[{
            show: isActive.dropdownList[itemIndex]
          }]"
        />
        <p 
          class="lv-info-multilayer__text"
          :class="[{
            'no-subLayers': !item.items.length,
            'selected': $_isSelected(item.id),
            disable,
            'no-pointer': !item.items.length,
          }]"
        >
          {{ item.name }}
        </p>
      </div>
      <LvInfoMultiLayer
        v-if="item.items && isActive.dropdownList[itemIndex]"
        :items="item.items"
        :value="value"
        @click="$_onClickSubItem($event)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "LvInfoMultiLayer",
  props: {
    items: {
      type: Array,
      required: true
    },
    value: {
      type: [Number, String],
    },
    disable: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      isActive: {
        dropdownList: []
      }
    }
  },
  mounted(){
    this.$_init()
  },
  methods: {
    $_init() {
      this.items.forEach(() => {
        this.isActive.dropdownList.push(false)
      })
    },
    $_onClick($event, item, itemIndex){
      if (this.disable) return;
      if ($event.target.tagName === "P") {
        this.$emit("click", item.id)
      } else {
        this.$set(
          this.isActive.dropdownList,
          itemIndex,
          !this.isActive.dropdownList[itemIndex]
        )
      }
    },
    $_onClickSubItem($event) {
      this.$emit("click", $event)
    },
    $_isSelected(id) {
      if (id == this.value) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>